import { useState } from 'react';
import { Clock } from '@phosphor-icons/react';
import './DayTimePicker.css';

const DAYS = [
  { id: 'sunday', label: 'א׳', fullLabel: 'ראשון' },
  { id: 'monday', label: 'ב׳', fullLabel: 'שני' },
  { id: 'tuesday', label: 'ג׳', fullLabel: 'שלישי' },
  { id: 'wednesday', label: 'ד׳', fullLabel: 'רביעי' },
  { id: 'thursday', label: 'ה׳', fullLabel: 'חמישי' },
  { id: 'friday', label: 'ו׳', fullLabel: 'שישי' },
  { id: 'saturday', label: 'ש׳', fullLabel: 'שבת' },
];

const HOURS = Array.from({ length: 19 }, (_, i) => i + 5); // 5:00 to 23:00

function DayTimePicker({ value = {}, onChange }) {
  const [activeDay, setActiveDay] = useState(null);

  const handleDayClick = (dayId) => {
    if (value[dayId]) {
      // If day is already selected, remove it
      const newValue = { ...value };
      delete newValue[dayId];
      onChange(newValue);
      if (activeDay === dayId) setActiveDay(null);
    } else {
      // Add day with default time range
      onChange({
        ...value,
        [dayId]: { from: 9, to: 17 },
      });
      setActiveDay(dayId);
    }
  };

  const handleTimeChange = (dayId, field, hour) => {
    const currentRange = value[dayId] || { from: 9, to: 17 };
    let newRange = { ...currentRange, [field]: hour };
    
    // Ensure from is always less than to
    if (field === 'from' && hour >= currentRange.to) {
      newRange.to = Math.min(hour + 1, 23);
    }
    if (field === 'to' && hour <= currentRange.from) {
      newRange.from = Math.max(hour - 1, 5);
    }
    
    onChange({
      ...value,
      [dayId]: newRange,
    });
  };

  const formatHour = (hour) => {
    return `${hour.toString().padStart(2, '0')}:00`;
  };

  return (
    <div className="day-time-picker">
      <div className="days-row">
        {DAYS.map((day) => (
          <button
            key={day.id}
            type="button"
            className={`day-btn ${value[day.id] ? 'selected' : ''} ${activeDay === day.id ? 'active' : ''}`}
            onClick={() => handleDayClick(day.id)}
            title={day.fullLabel}
          >
            <span className="day-label">{day.label}</span>
            {value[day.id] && (
              <span className="day-time">
                {formatHour(value[day.id].from)}-{formatHour(value[day.id].to)}
              </span>
            )}
          </button>
        ))}
      </div>

      {activeDay && value[activeDay] && (
        <div className="time-selector">
          <div className="time-selector-header">
            <Clock size={18} weight="regular" />
            <span>שעות ל{DAYS.find(d => d.id === activeDay)?.fullLabel}</span>
          </div>
          <div className="time-range">
            <div className="time-field">
              <label>מ-</label>
              <select
                value={value[activeDay].from}
                onChange={(e) => handleTimeChange(activeDay, 'from', parseInt(e.target.value))}
              >
                {HOURS.map((hour) => (
                  <option key={hour} value={hour}>
                    {formatHour(hour)}
                  </option>
                ))}
              </select>
            </div>
            <div className="time-separator">עד</div>
            <div className="time-field">
              <label>עד</label>
              <select
                value={value[activeDay].to}
                onChange={(e) => handleTimeChange(activeDay, 'to', parseInt(e.target.value))}
              >
                {HOURS.map((hour) => (
                  <option key={hour} value={hour}>
                    {formatHour(hour)}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}

      {Object.keys(value).length > 0 && (
        <div className="selected-summary">
          {DAYS.filter(day => value[day.id]).map(day => (
            <span key={day.id} className="summary-tag">
              {day.fullLabel}: {formatHour(value[day.id].from)} - {formatHour(value[day.id].to)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default DayTimePicker;

